"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssistantAppsOAuthClient = void 0;
const signalREvent_1 = require("../../../contracts/enum/signalREvent");
const baseHubClient_1 = require("./baseHubClient");
class AssistantAppsOAuthClient extends baseHubClient_1.BaseHubClient {
    constructor() {
        super(...arguments);
        this.listenToOAuth = (callBack) => {
            this.addListener(signalREvent_1.SignalRReceiveEvent.OAuthComplete, callBack);
        };
        this.removeListenToOAuth = (callBack) => {
            this.removeListener(signalREvent_1.SignalRReceiveEvent.OAuthComplete, callBack);
        };
        this.joinGroup = (channelId) => {
            this.sendPayload(signalREvent_1.SignalRSendEvent.JoinOAuthGroup, channelId);
        };
        this.leaveGroup = (channelId) => {
            this.sendPayload(signalREvent_1.SignalRSendEvent.LeaveOAuthGroup, channelId);
        };
    }
}
exports.AssistantAppsOAuthClient = AssistantAppsOAuthClient;
